import SideloadCell from './container';

export default SideloadCell;
